/* eslint-disable @typescript-eslint/no-explicit-any */
import { createPopper } from '@popperjs/core';
import { ButtonHTMLAttributes, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as ArrowDown } from '../../../assets/svg/ArrowDownPerm.svg';
import { useOutsideAlerter } from '../../../hooks';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    size?: 'small' | 'normal';
    options: { label?: string, value: any }[],
    children?: React.ReactNode;
    onChange?: (value: any) => void,
}

function SplitButton({ options, size, onChange, ...props }: ButtonProps) {
    const [isExpand, setIsExpand] = useState(false);
    // const [val, setVal] = useState<any>(undefined);
    const refDiv = useRef<HTMLDivElement | null>(null);
    const wrapperRef = useRef(null);

    useOutsideAlerter(refDiv, setIsExpand);

    useEffect(() => {
        if (refDiv.current && wrapperRef.current) {
            createPopper(wrapperRef.current, refDiv.current, {
                placement: 'bottom-start',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 4],
                        },
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top-start', 'top-end'],
                        },
                    },
                ],
            });
        }
    }, [isExpand]);

    const cls = `btn _bd ${props.disabled ? '_disabled' : ''} ${size === 'small' ? '_min' : ''} ${props.className || ''}`;
    return (
        <div
            style={{ display: 'inline-flex', position: 'relative', width: '100%' }}
        >
            <button
                type="button"
                className={cls}
                style={{
                    flex: '1 1 auto',
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    marginLeft: 0,
                    position: 'relative',
                    float: 'left',
                    // display: 'inline-flex',
                    cursor: 'pointer',
                    userSelect: 'none',
                    alignItems: 'center',
                    textAlign: 'center',
                    overflow: 'hidden',
                }}
                onClick={props.onClick}
            >
                {props.children}
            </button>
            <button
                ref={wrapperRef}
                className={cls}
                type="button"
                aria-expanded="false"
                aria-haspopup="true"
                style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    width: '3rem',
                    padding: '0.75rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: 0,
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'bottom',
                    textAlign: 'center',
                    overflow: 'hidden',
                    position: 'relative',
                    boxSizing: 'border-box',
                }}
                onClick={() => setIsExpand((v) => !v)}
            >
                <ArrowDown style={{ margin: 0, stroke: 'white' }} />
            </button>
            {isExpand && ReactDOM.createPortal(
                <div
                    ref={refDiv}
                    className={'comboInput__list _single _min'}
                    style={{
                        display: 'block',
                        position: 'absolute',
                        inset: '0px auto auto 0px',
                        margin: '0px',
                        zIndex: 50,
                    }}
                >
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={'comboInput__list-item'}
                            onClick={() => {
                                onChange && onChange(option.value);
                                setIsExpand(false);
                            }}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
                , document.body)}
        </div>
    );
}

export default SplitButton;